import './LayoutTwo.scss';
import { Container, Row, Col } from 'react-bootstrap'
import { useForm, Controller } from 'react-hook-form'
import { useState, useEffect } from 'react';
import Popup from './Popup'
import PopupMessage from './PopupMessage'
import parse from 'html-react-parser'
import { registerUser } from '../client-logic/register-user'
import { registerMemberMailchimp } from '../client-logic/register-member-mail'
import Select from 'react-select'
import './Select.scss';



function LayoutTwo({ appJson: _appJson }) {

  const appJson = {
    ..._appJson,
    rows: _appJson.rows.map(r => {
      return {
        ...r, fields: r.fields.map(f => {
          return {
            ...f,
            "isMulti": f.isMulti || false,
            "key": f.key || "",
            "acceptanceKey": f.acceptanceKey || "",
            "required": f.required || false,
            "label": f.label || "",
            "help": f.help || "",
            "options": f.options || [],
            "metaHasOptions": f.metaHasOptions || false,
            "metaIsMulti": f.metaIsMulti || false,
            "metaOptions": f.metaOptions || [],
            "format": f.format || "",
            "validationMessage": f.validationMessage || "",
            "modalContent": f.modalContent || "",
            "modalButton": f.modalButton || ""
          };
        })
      }
    })
  }

    const { register, handleSubmit, control } = useForm()
    const [isPopup, setIsPopup] = useState(false)
    const [isPopupMessage, setIsPopupMessage] = useState(false)
    const handleClose = () => {
        setIsPopupMessage(false)
        if (title !== 'Error') window.location.replace(appJson.redirectUrl)
    }
    const handleShow = () => setIsPopupMessage(true)
    const [message, setMessage] = useState('')
    const [title, setTitle] = useState('')
    const [isSubmited, setIsSubmited] = useState(false)
    const [metaKey, setMetaKey] = useState()


    const colourStyles = {
        control: styles => ({
            ...styles,
            backgroundColor: '#f5f7f8',
            border: '0',
            boxShadow: 'none',
            minHeight: '50px',
        }),
        menu: styles => ({
            ...styles,
            backgroundColor: 'white',
        }),
        option: (styles, { isDisabled }) => {
            return {
                ...styles,
                backgroundColor: 'white',
                color: '#555555',
                textAlign: 'left',
                cursor: isDisabled ? 'not-allowed' : 'default',
                ':active': {
                    ...styles[':active'],
                    backgroundColor: 'white',
                },
                ':hover': {
                    ...styles[':hover'],
                    backgroundColor: 'rgba(85, 85, 85, 0.1)',
                },
            };
        },
        valueContainer: styles => {
            return {
                ...styles,
                padding: '1px'
            }
        },
        placeholder: styles => {
            return {
                ...styles,
                paddingBottom: '0px',
                marginLeft: '5px',
                fontSize: '0.8em'
            };
        },

        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: 'white',
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#555555',
            padding: '2px',
            borderRadius: '4px 0px 0px 4px',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#e6e6e6',
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#555555',
            backgroundColor: '#e6e6e6',
            borderRadius: '0px 4px 4px 0px',
            width: '20px',
            ':hover': {
                width: '20px',
                backgroundColor: '#ffbdad',
                color: '#e55939',
            },
        }),
    };



    useEffect(() => {
        setIsSubmited(false)
    }, [])


    const onSubmit = async (formData) => {
        try {
            delete formData.fake
            delete formData.fakeAudience
            setIsSubmited(true)
            if (formData?.audiences?.length && typeof (formData?.audiences) !== 'string') {
                const audiences = formData.audiences.map(item => item.key)
                formData.audiences = audiences
            }
            if (formData?.audiences?.length && typeof (formData.audiences) === 'string') formData.audiences = [formData.audiences]
            if (formData?.audiences?.length === 0) delete formData.audiences
            if (Object.keys(formData).includes('metaMulti')) {
                const metaMultis = formData.metaMulti.map(item => item.key)
                formData.meta[`${metaKey}`] = metaMultis
                delete formData.metaMulti
            }

            formData.appId = appJson.ubelongSlug
            await registerUser(formData)
            setTitle(appJson.messages.signupCompletedTitle)
            setMessage(appJson.messages.signupCompletedMessage)
            handleShow()

            addMemberToMailchimp(formData)

        } catch (error) {
            setTitle('Error')
            const { response: { data: { message } } } = error
            switch (message) {
                case 'Invite code not found':
                    setMessage(appJson.messages.invalidCodeMessage)
                    break;
                case 'Invite code already used':
                    setMessage(appJson.messages.usedCodeMessage)
                    break;
                case 'email: value already exists.':
                    setMessage(appJson.messages.emailExistsMessage)
                    break;
                default:
                    setMessage(appJson.messages.unknownErrorMessage)
                    break;
            }
            setIsSubmited(false)
            handleShow()
        }
    }

    const addMemberToMailchimp = async (formData) => {
        let mergeFields = {}
        Object.keys(formData).forEach(key => {

            if (key === 'meta') {

                Object.keys(formData[`${key}`]).forEach(keyMeta => {
                    if(Array.isArray(formData[`${key}`][`${keyMeta}`])){
                        mergeFields[`${keyMeta.toUpperCase()}`] = formData[`${key}`][`${keyMeta}`].join(', ')
                    }else {
                        mergeFields[`${keyMeta.toUpperCase()}`] = formData[`${key}`][`${keyMeta}`]
                    }
                })
            } else if (key === 'audiences') {
                mergeFields[`${key.toUpperCase()}`] = formData[`${key}`][0]
            }
            else {
                if (formData[`${key}`] === true) formData[`${key}`] = 'true'
                if (formData[`${key}`] === false) formData[`${key}`] = 'false'
                mergeFields[`${key.toUpperCase()}`] = formData[`${key}`]
            }
        })
        const { mailchimpApiKey, mailchimpServer, mailchimpListId, mailchimpEnable } = appJson
        try {
            delete mergeFields.PASSWORD
            delete mergeFields.APPID
            delete mergeFields[0]
            if (mailchimpEnable) {
                /*const res =*/ await registerMemberMailchimp(
                {
                    apiKey: mailchimpApiKey,
                    server: mailchimpServer,
                    mailchimpId: mailchimpListId,
                    email: formData.email,
                    status: 'subscribed',
                    mergeFields: mergeFields
                })
            }
        } catch (error) {
            console.log(error)
        }
    }


    return (
        <div className='layout-two'>
            <Container fluid>
                <Row>
                    <Col className='layout-two-left'
                        style={{
                            backgroundColor: appJson.themeColor,
                            backgroundImage: `url(${appJson.backgroundImage})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                        }}
                        md={4}>
                        <Row className='layout-two-left-row'>
                            {appJson?.logo?.length > 0 && <img src={appJson.logo} alt='logo' />}
                        </Row>
                        <Row className='layout-two-left-html' md={1} >
                            {parse(`${appJson.leftBarHTML}`)}
                        </Row>
                    </Col>
                    <Col className='layout-two-right' md={8} >
                        <form onSubmit={handleSubmit(onSubmit)} className='layout-two-right-form'>
                            <Row classname='layout-two-right-row-title' >
                                <h1>{appJson.title}</h1>
                            </Row>
                            {
                                appJson.rows.map(row =>

                                    <Row className='layout-two-right-row' style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        {
                                            row.fields.map((field, i) =>
                                                field._template === 'audience' ?
                                                    !field.isMulti ?
                                                        <Col
                                                            sm={row.fields.length === 1 ? 12 : 12}
                                                            md={row.fields.length === 1 ? 12 : 6}
                                                            className={'layout-two-right-select-large'}>
                                                            <label>{field.label}<span>{field.required ? ` *` : ''}</span></label>
                                                            <select
                                                                name={field.label}
                                                                required={field.required}
                                                                className='layout-two-right-select'
                                                                {...register('audiences')}
                                                                onInput={({ target }) => {
                                                                    !target.value.length ?
                                                                        target.setCustomValidity(appJson.messages.requiredFieldMessage) :
                                                                        target.setCustomValidity('')
                                                                }}
                                                                onInvalid={({ target }) => {
                                                                    target.setCustomValidity(appJson.messages.requiredFieldMessage)
                                                                }}
                                                            >
                                                                <option value="" disabled selected >{`${field.label}`}</option>
                                                                {
                                                                    field.options.map(option =>
                                                                        <option value={option.key}>{option.label}</option>
                                                                    )
                                                                }
                                                            </select>
                                                            <p className='layout-two-right-row-help'>{field.help}</p>
                                                        </Col> :
                                                        <Col
                                                            sm={row.fields.length === 1 ? 12 : 12}
                                                            md={row.fields.length === 1 ? 12 : 6}
                                                            className={'layout-two-right-select-large'}>
                                                            <label>{field.label}<span>{field.required ? ` *` : ''}</span></label>

                                                            <Controller
                                                                name={'audiences'}
                                                                control={control}
                                                                rules={{ required: field.required }}
                                                                render={({ field: fieldSelect }) => {
                                                                    return <Select
                                                                        {...fieldSelect}
                                                                        placeholder={field.label}
                                                                        styles={colourStyles}
                                                                        options={field.options}
                                                                        getOptionValue={(option) => `${option['key']}`}
                                                                        isMulti={true}
                                                                        // onMenuOpen={() => setMetaKey(field.key)}
                                                                        onInputChange={(e) => {
                                                                            if (field.required) {
                                                                                document.getElementById(`hidden-required-${field._template}`).value = "My value"
                                                                                document.getElementById(`hidden-required-${field._template}`).setCustomValidity('')
                                                                            }
                                                                        }}
                                                                    />
                                                                }}
                                                            />
                                                            {
                                                                field.required && field?.isMulti &&
                                                                <input
                                                                    style={{
                                                                        opacity: 0,
                                                                        width: "0px",
                                                                        height: '62px',
                                                                        position: "absolute",
                                                                        left: appJson.wideMode ? '65%' : '40%'
                                                                    }}
                                                                    tabIndex={-1}
                                                                    id={`hidden-required-${field._template}`}
                                                                    name={field.label}
                                                                    type='text'
                                                                    pattern={field.format.length ? field.format : '^.{1,50}$'}
                                                                    required={field.required}
                                                                    {...register('fakeAudience')}
                                                                    onInput={({ target }) => {
                                                                        !target.value.length ?
                                                                            target.setCustomValidity(appJson.messages.requiredFieldMessage) :
                                                                            target.setCustomValidity('')
                                                                    }}
                                                                    onInvalid={({ target }) => {
                                                                        !target.value.length ?
                                                                            target.setCustomValidity(appJson.messages.requiredFieldMessage) :
                                                                            target.setCustomValidity('')
                                                                    }}



                                                                />
                                                            }
                                                            <p className='layout-two-right-row-help'>{field.help}</p>
                                                        </Col> :
                                                    field._template === 'acceptance' ?
                                                        <Col
                                                            sm={row.fields.length === 1 ? 12 : 12}
                                                            md={row.fields.length === 1 ? 12 : 6}
                                                            className={'layout-two-right-input-checkbox'}>

                                                            <input
                                                                {...register(field.acceptanceKey.length ? field.acceptanceKey : `${i}`)}
                                                                required={field.required}
                                                                type='checkbox'
                                                                onInput={({ target }) => {
                                                                    !target.checked && field.required ?
                                                                        target.setCustomValidity(appJson.messages.requiredFieldMessage) :
                                                                        target.setCustomValidity('')
                                                                }}
                                                                onInvalid={({ target }) => {
                                                                    target.setCustomValidity(appJson.messages.requiredFieldMessage)
                                                                }}
                                                            />
                                                            <label>
                                                                {field.label}
                                                                <span onClick={() => setIsPopup(true)} className={'layout-two-right-input-checkbox-modallink'}>{field.modalButton && field.modalButton}</span>
                                                                {field.modalButton && field.required && '*'}
                                                            </label>
                                                            {/* <span className={'layout-two-right-input-checkbox-required'}>{field.required && ` *`}</span> */}
                                                            <Popup show={isPopup} size={'lg'} onHide={() => setIsPopup(false)} content={field.modalContent} />
                                                            <p className='layout-two-right-row-help'>{field.help}</p>
                                                        </Col> :

                                                        !field.metaHasOptions ?


                                                            <Col
                                                                sm={row.fields.length === 1 ? 12 : 12}
                                                                md={row.fields.length === 1 ? 12 : 6}
                                                                className={'layout-two-right-input-large'}>
                                                                <label>{field.label}<span>{field.required ? ` *` : ''}</span></label>
                                                                <input
                                                                    {...register(field._template === 'meta' ? `meta.${field.key}` : field._template)}
                                                                    className='layout-two-right-input'
                                                                    pattern={field.format.length ? field.format : '^.{1,50}$'}
                                                                    required={field.required}
                                                                    type={field._template === 'password' ? 'password' : 'text'}
                                                                    onInvalid={({ target }) => {
                                                                        target.validity.patternMismatch ?
                                                                            target.setCustomValidity(field.validationMessage) :
                                                                            target.value.length === 0 ?
                                                                                target.setCustomValidity(appJson.messages.requiredFieldMessage) :
                                                                                target.setCustomValidity('')
                                                                    }}
                                                                    onInput={({ target }) => {
                                                                        !target.value.length && field.required ?
                                                                            target.setCustomValidity(appJson.messages.requiredFieldMessage) :
                                                                            target.setCustomValidity('')
                                                                    }} />
                                                                <p className='layout-two-right-row-help'>{field.help}</p>
                                                            </Col> :

                                                            !field.metaIsMulti ?

                                                                <Col
                                                                    sm={row.fields.length === 1 ? 12 : 12}
                                                                    md={row.fields.length === 1 ? 12 : 6}
                                                                    className={'layout-two-right-select-large'}>
                                                                    <label>{field.label}<span>{field.required ? ` *` : ''}</span></label>
                                                                    <select
                                                                        name={field.label}
                                                                        required={field.required}
                                                                        className='layout-two-right-select'
                                                                        {...register(field._template === 'meta' ? `meta.${field.key}` : field._template)}
                                                                        onInput={({ target }) => {
                                                                            !target.value.length ?
                                                                                target.setCustomValidity(appJson.messages.requiredFieldMessage) :
                                                                                target.setCustomValidity('')
                                                                        }}
                                                                        onInvalid={({ target }) => {
                                                                            target.setCustomValidity(appJson.messages.requiredFieldMessage)
                                                                        }}
                                                                    >
                                                                        <option value="" disabled selected >{`${field.label}`}</option>
                                                                        {
                                                                            field.metaOptions.map(option =>
                                                                                <option value={option.key}>{option.label}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                    <p className='layout-two-right-row-help'>{field.help}</p>
                                                                </Col> :

                                                                <Col
                                                                    sm={row.fields.length === 1 ? 12 : 12}
                                                                    md={row.fields.length === 1 ? 12 : 6}
                                                                    className={'layout-two-right-select-large'}>

                                                                    <label>{field.label}<span>{field.required ? ` *` : ''}</span></label>

                                                                    <Controller
                                                                        name={`metaMulti`}
                                                                        control={control}
                                                                        rules={{ required: field.required }}
                                                                        render={({ field: fieldSelect }) => {
                                                                            return <>
                                                                                <Select
                                                                                    id='multi-select'
                                                                                    placeholder={field.label}
                                                                                    {...fieldSelect}
                                                                                    // className={row.fields.length > 1 ? 'select-multi' : 'select-multi-wide'}
                                                                                    styles={colourStyles}
                                                                                    options={field.metaOptions.map((o, i) => ({ label: o.label, key: o.label }))}
                                                                                    getOptionValue={(option) => `${option['key']}`}
                                                                                    isMulti={true}
                                                                                    onMenuOpen={() => setMetaKey(field.key)}
                                                                                    onInputChange={(e) => {
                                                                                        if (field.required) {
                                                                                            document.getElementById(`hidden-required-meta-${field.key}`).value = "My value"
                                                                                            document.getElementById(`hidden-required-meta-${field.key}`).setCustomValidity('')
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </>
                                                                        }}
                                                                    />
                                                                    {
                                                                        field.required && field?.metaIsMulti &&
                                                                        <input
                                                                            style={{
                                                                                opacity: 0,
                                                                                width: "0px",
                                                                                height: '62px',
                                                                                position: "absolute",
                                                                                left: appJson.wideMode ? '40%' : '40%'
                                                                            }}
                                                                            tabIndex={-1}
                                                                            id={`hidden-required-meta-${field.key}`}
                                                                            name={field.label}
                                                                            type='text'
                                                                            pattern={field.format.length ? field.format : '^.{1,50}$'}
                                                                            required={field.required}
                                                                            {...register('fake')}
                                                                            onInput={({ target }) => {
                                                                                !target.value.length ?
                                                                                    target.setCustomValidity(appJson.messages.requiredFieldMessage) :
                                                                                    target.setCustomValidity('')
                                                                            }}
                                                                            onInvalid={({ target }) => {
                                                                                !target.value.length ?
                                                                                    target.setCustomValidity(appJson.messages.requiredFieldMessage) :
                                                                                    target.setCustomValidity('')
                                                                            }}



                                                                        />
                                                                    }
                                                                </Col>

                                            )
                                        }
                                    </Row>
                                )
                            }

                            <Row className='layout-two-right-row' style={{ display: 'flex', justifyContent: 'center' }}>
                                <Col className='layout-two-right-button' md={6}>
                                    {
                                        <input
                                            disabled={isSubmited}
                                            type='submit'
                                            value={appJson.registerButton}
                                            style={{ backgroundColor: appJson.themeColor }}
                                        />
                                    }
                                </Col>
                            </Row>

                            {
                                // errorMessage?.length &&
                                <PopupMessage
                                    show={isPopupMessage}
                                    handleClose={handleClose}
                                    setIsPopupMessage={setIsPopupMessage}
                                    onHide={() => setIsPopupMessage(false)}
                                    buttonColor={appJson.themeColor}
                                    message={message}
                                    title={title}
                                />
                            }

                        </form>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default LayoutTwo;
